/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ComponentLike, ContentValue } from '@glint/template';

interface BvRadioSignature {
  Args: {
    ariaDescribedBy?: string;
    checked?: boolean;
    disabled?: boolean;
    helpText?: string;
    id?: string;
    label?: ContentValue | ComponentLike;
    labelClass?: string;
    labelHidden?: boolean;
    name?: boolean;
    onBlur?: () => void;
    onChange?: () => void;
    onFocus?: () => void;
    onMouseOut?: () => void;
    onMouseOver?: () => void;
    value?: boolean;
  };
  Element: HTMLSpanElement;
}

const BvRadioComponent = templateOnlyComponent<BvRadioSignature>();

export default BvRadioComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvRadio: typeof BvRadioComponent;
    'bv-radio': typeof BvRadioComponent;
  }
}
